import PropTypes from "prop-types";

export const _NavMenuRevamp = {
  children: PropTypes.node,
};

export const NavMenuRevampPropTypes = _NavMenuRevamp;
